import * as React from 'react'
import classnames from 'classnames'

import styles from '../styles.module.scss'
import { useField } from 'formik'

export const Input: React.FC<React.HTMLProps<HTMLInputElement>> = ({ className, ...rest }) => {
  const [, meta] = useField(rest.name)
  const inputClassName = classnames(styles.input, className, {
    [styles.inputError]: meta.error && meta.touched,
  })

  return <input autoComplete="off" className={inputClassName} {...rest} />
}
